import * as _ from "lodash";
import { Utils } from "../common/utils";
import { BaseBrandedView } from "./_BaseViews";
export class FooterView extends BaseBrandedView {
    constructor(options) {
        super(
            <any>_.extend(options, {
                el: ".footer",
            })
        );
    }

    render() {
        Utils.loadAsset(`${window["CONFIG"].portal1.url}/ui25/fragments/common/nav/public/css/footer.css`, "css")
            .then(() => {
                console.log("Footer asset loaded");

                $.ajax({
                    url: `${window["CONFIG"].portal1.url}/ui25/fragments/common/nav/footer`,
                    method: "GET",
                    beforeSend: function (xhr) {
                        (xhr as any)._source = "footer";
                    },
                    success: function (response) {
                        if ($("#footerContainer").is(":empty")) {
                            $("#footerContainer").html(response);
                        }
                    },
                    error: function (xhr) {
                        console.error("Failed to fetch footer fragment:", xhr);
                    },
                });
            })
            .catch((error) => {
                console.error("Failed to load footer asset:", error);
            });

        return this;
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/Footer.ts